module.exports = __webpack_public_path__ + "static/media/set-aside-icon.ce3b7715.svg";